<template>
    <div>
      <Header :title="title"/>
      
  
      <div class="content_podat">
        <div v-for="g in arr" :key="g.god" class="block_radio">
          <input
            class="custom-radio"
            name="color"
            v-model="god"
            type="radio"
            :id="g.god"
            :value="g.god"
            @change="select"
          />
          <label :for="g.god">{{g.god}}</label>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Header from '../components/headerpodat'
  export default {
     components:{
     Header
     },
    data() {
      return {
        title:"Выберите год выпуска",
        god: "",
        kateg:"",
        kateg_text:"",
        razdel:"",
        razdel_text:"",
        marka:"",
        marka_text:"",
        model:"",
        model_text:"",
        tip:"",
        tip_text:"",
        obmen:"",
        obmen_text:"",
         arr: [
          {god: 2025},{god: 2024},{god: 2023},{god: 2022},{god: 2021},{god: 2020},{god: 2019},{god: 2018},{god: 2017},
          {god: 2016},{god: 2015},{god: 2014},{god: 2013},{god: 2012},{god: 2011},
          {god: 2010},{god: 2009},{god: 2008},{god: 2007},{god: 2006},{god: 2005},
          {god: 2004},{god: 2003},{god: 2002},{god: 2001},{god: 2000},{god: 1999},
          {god: 1998},{god: 1997},{god: 1996},{god: 1995},{god: 1994},{god: 1993},
          {god: 1992},{god: 1991},{god: 1990},{god: 1989},{god: 1988},{god: 1987},
          {god: 1986},{god: 1985},{god: 1984},{god: 1983},{god: 1982},{god: 1981},
          
        ],
      };
    },
    methods: {
      select() {
        localStorage.setItem("obmen_god",this.god);
        if (this.obmen){
            if (this.kateg=="avto"){
                this.obmen = this.obmen+"+"+this.kateg+"|"+this.marka+"|"+this.model+"|"+this.god;
                this.obmen_text = this.obmen_text+"+"+this.kateg_text+"|"+this.marka_text+"|"+this.model_text+"|"+this.god;
            }else{
                this.obmen =this.obmen+"+"+this.kateg+"|"+this.razdel+"|"+this.marka+"|"+this.tip+"|"+this.god;
                this.obmen_text =this.obmen_text+"+"+this.kateg_text+"|"+this.razdel_text+"|"+this.marka_text+"|"+this.tip_text+"|"+this.god;
            }
        }
        else{
          if (this.kateg=="avto"){
                this.obmen = this.kateg+"|"+this.marka+"|"+this.model+"|"+this.god;
                this.obmen_text = this.kateg_text+"|"+this.marka_text+"|"+this.model_text+"|"+this.god;
            }else{
                this.obmen = this.kateg+"|"+this.razdel+"|"+this.marka+"|"+this.tip+"|"+this.god;
                this.obmen_text = this.kateg_text+"|"+this.razdel_text+"|"+this.marka_text+"|"+this.tip_text+"|"+this.god;
            }
        }
        if(localStorage.getItem("statusobmen")=="obmen"){
          this.$store.commit("addpodatobmen",this.obmen);
          this.$store.commit("addpodatobmentext",this.obmen_text);
       }
        
         this.dale();
  
      },
      dale() {
       if(localStorage.getItem("statusobmen")=="obmen"){
        this.$router.push({ name: "obmenpodat" });  
       }else{
        localStorage.setItem("ukazat",true);
        this.$router.push({ name: "obmen" });  
       }
       
      },
    },
    computed: {
      getobmen() {
        return this.$store.getters.getpodatobmen;
      },
       getobmentext() {
        return this.$store.getters.getpodatobmentext;
      },
     },
     mounted (){
        if(this.getobmen){
        this.obmen=this.getobmen;
        }
        if(this.getobmentext){
        this.obmen_text=this.getobmentext;
        }
        if(localStorage.getItem("obmen_kateg")){
        this.kateg=localStorage.getItem("obmen_kateg");
        }
        if(localStorage.getItem("obmen_kateg_text")){
        this.kateg_text=localStorage.getItem("obmen_kateg_text");
        }
        if(localStorage.getItem("obmen_razdel")){
        this.razdel=localStorage.getItem("obmen_razdel");
        }
        if(localStorage.getItem("obmen_razdel_text")){
        this.razdel_text=localStorage.getItem("obmen_razdel_text");
        }
        if(localStorage.getItem("obmen_marka")){
        this.marka=localStorage.getItem("obmen_marka");
        }
        if(localStorage.getItem("obmen_marka_text")){
        this.marka_text=localStorage.getItem("obmen_marka_text");
        }
        if(localStorage.getItem("obmen_model")){
        this.model=localStorage.getItem("obmen_model");
        }
        if(localStorage.getItem("obmen_model_text")){
        this.model_text=localStorage.getItem("obmen_model_text");
        }
        if(localStorage.getItem("obmen_tip")){
        this.tip=localStorage.getItem("obmen_tip");
        }
        if(localStorage.getItem("obmen_tip_text")){
        this.tip_text=localStorage.getItem("obmen_tip_text");
        }
        
  }
    
  
  };
  </script>
  <style scoped>
  .block_radio {
    margin-bottom: 1.4em;
  }
  .divgorod {
    width: 100%;
    color: #777777;
  }
  .contentgorod {
    font-size: 20px;
    border-bottom: 1px solid #000000;
    padding: 5px 5px 5px 0px;
  }
  label {
    font-size: 18px;
    width: 100%;
  }
  .content_podat {
    padding: 90px 5px 65px 10px;
  }
  </style>